export default __webpack_public_path__ + "static/media/img-soon-2.8a568d58.svg";